import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { HhsgSharedUserProfile } from '../../../models';
import { UserMenuItemModel } from '../../../models/user-menu-item.model';

@Component({
  selector: 'huron-user-menu',
  templateUrl: 'user-menu.component.html',
  styleUrls: ['./user-menu.component.scss']
})

export class HuronUserMenuComponent {
  @Input() menuItems: UserMenuItemModel[];
  @Input() menuMode: string;
  @Input() user: HhsgSharedUserProfile;

  defaultMenuItems: UserMenuItemModel[] = [
    new UserMenuItemModel(this.router, 'Profile', 'person', '/profile'),
    new UserMenuItemModel(this.router, 'Logout', 'power_rounded', '/logout'),
  ];
  constructor(private router: Router) {
    this.menuItems = this.filterMenuItems(this.defaultMenuItems);
  }

  filterMenuItems(menuItems: UserMenuItemModel[]): UserMenuItemModel[] {
    return menuItems.filter((item) => item.routeExists);
  }

  onItemClick(menuItem: UserMenuItemModel) {
    this.router.navigate([menuItem.routeUrl]);
  }  
}
